import React, { Component } from "react";
import { Navigate } from "react-router-dom";
import { withRouter } from '../../common/with-router';
import {Card, Form, Button, Row, Col, Table, Dropdown} from "react-bootstrap";
import { FaPlus, FaRegEdit, FaSearch, FaFilter, FaFileExport, FaTrash } from "react-icons/fa";
import api from "../../services/api";
import { formataDataExibicao, hasPerm, formataCPF, getCurrentUser } from '../../common/utils';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import Paginacao from '../../common/pagination';

class Operadores extends Component {
    constructor(props) {
        super(props);
        this.onChangeBusca = this.onChangeBusca.bind(this);
        this.onClickPagina = this.onClickPagina.bind(this);

        this.state = {
            listOperadores: [],
            error: "",
            busca: "",
            page_numb: 1,
            habilitarExcluir: false,
            loading: true,
        };
    }

    componentDidMount(){
        this.consultaOperadores(this.state.busca, this.state.page_numb)
    }

    consultaOperadores(busca, page_numb=1){
        api.get(`/pessoas/operadores/?nome=${busca}&page=${page_numb}`)
        .then(response => {
            this.setState({
                loading: false,
                error: "",
                listOperadores: response.data
            });
        })
        .catch(error => {
            let erro_msg = 'Erro ao consultar operadores, tente novamente.';

            if(error.response.status === 500){
                erro_msg = 'Servidor indisponível no momento';
            }
            else if(error.response.status === 403){
                erro_msg = 'Você não tem permissão acessar essa área';
            }

            this.setState({
                loading: false,
                error: erro_msg
            });
        });
    }

    excluirOperador(item){
        const MySwal = withReactContent(Swal);
        MySwal.fire({
            title: 'Tem certeza que deseja excluir o navegador '+item.dados_pessoa.nome+'?',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
        }).then((result) => {
            if (result.isConfirmed) {
                api.delete(`/pessoas/operadores/${item.id}`)
                .then(response => {
                    MySwal.fire({
                        title: 'Navegador excluído com sucesso',
                        icon: 'success',
                    });
                })
                .catch(error => {
                    MySwal.fire({
                        title: 'Erro ao excluir navegador',
                        icon: 'error',
                    });
                });
            }
        });
    }

    renderRows = () => {
        let dados_usuario = getCurrentUser();
        console.error(dados_usuario);
        if('results' in this.state.listOperadores && this.state.listOperadores.results.length > 0){
            return this.state.listOperadores.results.map((item) =>
            <tr key={item.id}>
                <td>{item.id}</td>
                <td>{item.dados_pessoa.nome}</td>
                <td>{item.dados_pessoa.email}</td>
                <td>{item.dados_pessoa.celular}</td>
                <td>
                    <Button variant="light" href={"/operadores/edit/"+item.id} size="sm">
                        <FaRegEdit /> Editar
                    </Button>  
                    {this.state.habilitarExcluir && dados_usuario['is_superuser'] && (
                        <Button variant="light" onClick={() => this.excluirOperador(item)} size="sm">
                            <FaTrash /> Excluir
                        </Button>  
                    )}  
                </td>
            </tr>
            );
        }        

        return (
            <tr>
                <td colSpan={5}>Nenhum navegador cadastrado</td>
            </tr>
        );
    };

    onChangeBusca(e) {
        const busca = e.target.value;
        this.setState({
            busca: busca
        });

        if (this.searchTimeout) {
            clearTimeout(this.searchTimeout);
        }

        this.searchTimeout = setTimeout(() => {
            this.setState({
                loading: true,
            });
            this.consultaOperadores(busca);
        }, 500);
    }

    onClickPagina(num_page) {
        this.setState({
            loading: true,
            page_numb: num_page
        });
        
        this.consultaOperadores(this.state.busca, num_page)
    };

    render() {
        if (!hasPerm('view_operadores')) {
            return <Navigate to='/sem-permissao' />
        }

        return (
            <div>
                <Row className="align-items-center">
                    <Col sm={6} lg={6}>
                        <h4 className="page-title">Navegadores</h4>
                    </Col>
                    <Col sm={6} lg={6} className="text-end">
                        <Button variant="secondary" href="/operadores/add" className="mb-3" size="sm">
                            <FaPlus /> Adicionar Navegador
                        </Button>
                    </Col>
                </Row>
                <Card className="cardDestaque">
                    <Card.Body>                    
                        <Row>
                            <Col sm={4} lg={4} className="mb-3">
                                <Form.Group>
                                    <Form.Label>Filtrar por nome</Form.Label>
                                    <Form.Control
                                        type="text"
                                        name="busca"
                                        value={this.state.busca}
                                        onChange={this.onChangeBusca}
                                        placeholder="Nome do navegador"
                                    />
                                </Form.Group>
                            </Col>
                        </Row>    

                        <Table responsive className="custom-table">
                            <thead>
                                <tr>
                                    <th>Id</th>
                                    <th>Nome</th>
                                    <th>E-mail</th>
                                    <th>Celular</th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                {this.state.loading ? (
                                <tr>
                                    <td colSpan={5}>Carregando...</td>
                                </tr>
                                ) : (
                                    this.state.error ? (
                                        <tr>
                                            <td colSpan={5}>{this.state.error}</td>
                                        </tr>
                                    ) : this.renderRows()
                                )}                                                       
                            </tbody>
                        </Table>       
                        { 
                            'results' in this.state.listOperadores && this.state.listOperadores.results.length > 0 && 
                            <Paginacao dados={this.state.listOperadores} loading={this.state.loading} page_numb={this.state.page_numb} _onClickPagina={this.onClickPagina} />
                        }                    
                    </Card.Body>                
                </Card>
            </div>
        );
    }
}

export default withRouter(Operadores);
